export default __webpack_public_path__ + "static/media/ic_nauru.7e55835a.svg";